<template>
  <div>
    <div class="d-flex fd-column fd-row:d jc-between m-b-1">
      <div>{{ authorName }}, {{ review.location }}</div>
      <div class="c-gray60">{{ reviewDate }}</div>
    </div>

    <div v-if="needsTruncating && !showFullReview" class="d-flex">
      {{ truncatedReview }}...
      <span class="c-depot text-bold m-l-auto" @click="showFullReview = true">Read more</span>
    </div>
    <div v-else>{{ review.text }}</div>
  </div>

</template>

<script>
import { format } from 'date-fns';

const TRUNCATE_LENGTH = 200;

export default {
  name: 'review',
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      showFullReview: false,
    };
  },
  computed: {
    authorName () {
      return this.review.author_name ? this.review.author_name.split(' ')[0] : 'Anonymous';
    },
    reviewDate () {
      return format(new Date(this.review.datetime), 'MMMM Do yyyy');
    },
    needsTruncating () {
      return this.review.text.length > TRUNCATE_LENGTH;
    },
    truncatedReview () {
      return this.review.text.substr(0, TRUNCATE_LENGTH);
    },
  },
};
</script>
